export default {
  MainAbout: 'About',
  MainOpenCourses: 'OpenCourses',
  MainHome: 'Home',
  MainReleaseNotes: 'ReleaseNotes',
  StudentActivityView: 'Activity',
  StudentCourseView: 'Course',
  StudentCourseJoin: 'CourseJoin',
  StudentProblemView: 'Problem',
  TeacherCourseEdit: 'CourseEdit',
  TeacherActivityEdit: 'ActivityEdit',
  TeacherProgress: 'TeachProgress',
  UserProfile: 'Profile',
  UserLogin: 'Login'
}
